export default __webpack_public_path__ + "static/media/SolSheep Song.d61a563a.mpeg";